// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var List = require("@mui/material/List").default;
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;
var Divider = require("@mui/material/Divider").default;
var MM_wrk_frag_transform = require("../worker/MM_wrk_frag_transform.bs.js");
var ListItem = require("@mui/material/ListItem").default;
var MM_cmp_single_frag_transf = require("./MM_cmp_single_frag_transf.bs.js");
var ListItemText = require("@mui/material/ListItemText").default;
var ListItemButton = require("@mui/material/ListItemButton").default;

var transformsTextCache = {
  contents: []
};

var allTransformsCache = {
  contents: []
};

function createInitialState(selectedSubtree) {
  return {
          selection: MM_wrk_frag_transform.syntaxTreeToSelection(selectedSubtree),
          transformsParseErr: undefined,
          availableTransforms: undefined,
          selectedTransform: undefined
        };
}

function setTransformsParseErr(st, str) {
  return {
          selection: st.selection,
          transformsParseErr: str,
          availableTransforms: st.availableTransforms,
          selectedTransform: st.selectedTransform
        };
}

function setAvailableTransforms(st, elem) {
  return {
          selection: st.selection,
          transformsParseErr: st.transformsParseErr,
          availableTransforms: Caml_option.some(elem),
          selectedTransform: st.selectedTransform
        };
}

function setSelectedTransform(st, tr) {
  return {
          selection: st.selection,
          transformsParseErr: st.transformsParseErr,
          availableTransforms: st.availableTransforms,
          selectedTransform: tr
        };
}

function MM_cmp_frag_transform(props) {
  var onUpdateCurrent = props.onUpdateCurrent;
  var onInsertBelow = props.onInsertBelow;
  var onInsertAbove = props.onInsertAbove;
  var transformsText = props.transformsText;
  var selectedSubtree = props.selectedSubtree;
  var onCancel = props.onCancel;
  var match = React.useState(function () {
        return createInitialState(selectedSubtree);
      });
  var setState = match[1];
  var state = match[0];
  var rndAvailableTransforms = function (availableTransforms) {
    var param = {
      selection: state.selection
    };
    var listItems = MM_wrk_frag_transform.unsafeFunc("Listing available transforms", (function (param$1) {
            return availableTransforms.map(function (availableTransform, i) {
                        return JsxPPXReactSupport.createElementWithKey(String(i), ListItem, {
                                    disablePadding: true,
                                    children: Caml_option.some(React.createElement(ListItemButton, {
                                              onClick: (function (param) {
                                                  Curry._1(setState, (function (__x) {
                                                          return setSelectedTransform(__x, availableTransform);
                                                        }));
                                                }),
                                              children: Caml_option.some(React.createElement(ListItemText, {
                                                        children: Caml_option.some(Curry._1(availableTransform.displayName, param))
                                                      }))
                                            }))
                                  });
                      });
          }));
    if (listItems.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: React.createElement(List, {
                    disablePadding: true,
                    children: Caml_option.some(listItems._0)
                  })
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: listItems._0
            };
    }
  };
  React.useEffect((function () {
          var param = {
            selection: state.selection
          };
          if (Caml_obj.notequal(transformsText, transformsTextCache.contents)) {
            var allTransformsRef = {
              contents: []
            };
            var availableTransformsElem = Belt_Result.flatMap(Belt_Result.flatMap(MM_wrk_frag_transform.arrStrToFragTransforms(transformsText), (function (allTransforms) {
                        allTransformsRef.contents = allTransforms;
                        return MM_wrk_frag_transform.unsafeFunc("Getting available transforms", (function (param$1) {
                                      return allTransforms.filter(function (tr) {
                                                  return Curry._1(tr.canApply, param);
                                                });
                                    }));
                      })), rndAvailableTransforms);
            if (availableTransformsElem.TAG === /* Ok */0) {
              var availableTransformsElem$1 = availableTransformsElem._0;
              transformsTextCache.contents = transformsText;
              allTransformsCache.contents = allTransformsRef.contents;
              Curry._1(setState, (function (__x) {
                      return setAvailableTransforms(__x, availableTransformsElem$1);
                    }));
            } else {
              var msg = availableTransformsElem._0;
              Curry._1(setState, (function (__x) {
                      return setTransformsParseErr(__x, msg);
                    }));
            }
          } else {
            var availableTransformsElem$2 = Belt_Result.flatMap(MM_wrk_frag_transform.unsafeFunc("Getting available transforms from cache", (function (param$1) {
                        return allTransformsCache.contents.filter(function (tr) {
                                    return Curry._1(tr.canApply, param);
                                  });
                      })), rndAvailableTransforms);
            if (availableTransformsElem$2.TAG === /* Ok */0) {
              var availableTransformsElem$3 = availableTransformsElem$2._0;
              Curry._1(setState, (function (__x) {
                      return setAvailableTransforms(__x, availableTransformsElem$3);
                    }));
            } else {
              var msg$1 = availableTransformsElem$2._0;
              Curry._1(setState, (function (__x) {
                      return setTransformsParseErr(__x, msg$1);
                    }));
            }
          }
        }), []);
  var actUnselectTransform = function (param) {
    Curry._1(setState, (function (__x) {
            return setSelectedTransform(__x, undefined);
          }));
  };
  var rndButtons = function (param) {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(React.createElement(Button, {
                          onClick: (function (param) {
                              Curry._1(onCancel, undefined);
                            }),
                          variant: "outlined",
                          children: "Cancel"
                        }))
              });
  };
  var rndContent = function (param) {
    var msg = state.transformsParseErr;
    if (msg !== undefined) {
      return React.createElement(Expln_React_Column.make, {
                  children: Caml_option.some(null)
                }, React.createElement("span", undefined, "Error: " + msg + ""), React.createElement("span", undefined, "Please make sure the custom transforms script is non-blank and valid or the \"Use custom transforms\" setting is unchecked."));
    }
    var selectedTransform = state.selectedTransform;
    if (selectedTransform !== undefined) {
      return React.createElement(MM_cmp_single_frag_transf.make, {
                  selection: state.selection,
                  transform: selectedTransform,
                  onBack: actUnselectTransform,
                  onInsertAbove: onInsertAbove,
                  onInsertBelow: onInsertBelow,
                  onUpdateCurrent: onUpdateCurrent
                });
    }
    var availableTransforms = state.availableTransforms;
    if (availableTransforms !== undefined) {
      return Caml_option.valFromOption(availableTransforms);
    } else {
      return "Loading available transforms...";
    }
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, rndContent(undefined), React.createElement(Divider, {}), rndButtons(undefined)))
            });
}

var make = MM_cmp_frag_transform;

exports.transformsTextCache = transformsTextCache;
exports.allTransformsCache = allTransformsCache;
exports.createInitialState = createInitialState;
exports.setTransformsParseErr = setTransformsParseErr;
exports.setAvailableTransforms = setAvailableTransforms;
exports.setSelectedTransform = setSelectedTransform;
exports.make = make;
/* react Not a pure module */
